import type { LaboratoryUserRead } from "@/types/api/types";
import { createSlice } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";

type State = {
  laboratoryUser: LaboratoryUserRead | null;
};

const initialState: State = {
  laboratoryUser: null,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setLaboratoryUser: (state, action) => {
      state.laboratoryUser = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  },
});

export const { setLaboratoryUser } = userSlice.actions;

export default userSlice.reducer;
